function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { nodeArray, objectAssign } from 'meteora';
var Gallery = /*#__PURE__*/function () {
  function Gallery(el) {
    var _this = this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, Gallery);
    this.gallery = el;
    this.slides = nodeArray(el.querySelectorAll('.js-gallery--item'));
    this.settings = objectAssign({
      autoplay: true,
      duration: 5000,
      dots: true
    }, options);
    this.info = {
      index: 0,
      autoplay: this.settings.autoplay
    };
    if (this.slides.length) {
      this.slides[0].classList.add('js-gallery--current');
      this.slides[0].classList.add('js-gallery--active');
    }
    if (this.slides.length >= 2) {
      this.play();
      if (this.settings.dots) {
        this.dots = document.createElement('div');
        this.dots.classList.add('js-gallery--dots');
        var canClick = true;
        this.slides.forEach(function (slide) {
          return _this.dots.appendChild(document.createElement('button'));
        });
        this.buttons = nodeArray(this.dots.children);
        this.buttons.forEach(function (button, index) {
          if (index === 0) button.classList.add('js-active');
          button.addEventListener('click', function () {
            if (canClick) {
              canClick = false;
              _this.goTo(index);
              if (_this.info.autoplay) _this.info.autoplay = false;
              setTimeout(function () {
                return canClick = true;
              }, 500);
            }
          });
        });
        this.gallery.appendChild(this.dots);
      }
    }
    ;
  }
  _createClass(Gallery, [{
    key: "play",
    value: function play() {
      var _this2 = this;
      if (this.info.autoplay) {
        setTimeout(function () {
          _this2.info.index = _this2.info.index >= _this2.slides.length - 1 ? 0 : _this2.info.index + 1;
          if (_this2.info.autoplay) _this2.goTo(_this2.info.index);
          _this2.play();
        }, this.settings.duration);
      }
    }
  }, {
    key: "goTo",
    value: function goTo(index) {
      var _this3 = this;
      if (typeof index === 'number' && index >= 0 && index <= this.slides.length) {
        this.info.index = index;
        this.buttons.forEach(function (button) {
          if (button === _this3.buttons[_this3.info.index]) {
            button.classList.add('js-active');
          } else {
            button.classList.remove('js-active');
          }
        });
        this.slides.forEach(function (slide) {
          var splitText = nodeArray(slide.querySelectorAll('.split'));
          splitText.forEach(function (item) {
            return item.style.overflow = 'hidden';
          });
          if (slide === _this3.slides[_this3.info.index]) {
            slide.classList.add('js-gallery--current');
            slide.classList.add('js-gallery--active');
            setTimeout(function () {
              splitText.forEach(function (item) {
                return item.style.overflow = 'visible';
              });
            }, 300);
          } else {
            slide.classList.remove('js-gallery--current');
            setTimeout(function () {
              slide.classList.remove('js-gallery--active');
            }, 300);
          }
        });
      }
    }
  }]);
  return Gallery;
}();
export { Gallery as default };